module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Winter Blessings")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780310354369_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Copyright#copy",
      "id": "rcopy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/nav"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780310354369_Glossary_P4#P4_1",
      "id": "rP4_1"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSSARY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780310354369_Ftree_P4#P4_2",
      "id": "rP4_2"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780310354369_Chapter1_P4#P4_3",
      "id": "rP4_3"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter2_P4#P4_4",
      "id": "rP4_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 2")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter3_P4#P4_5",
      "id": "rP4_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter4_P4#P4_6",
      "id": "rP4_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter5_P4#P4_7",
      "id": "rP4_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter6_P4#P4_8",
      "id": "rP4_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter7_P4#P4_9",
      "id": "rP4_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Chapter8_P4#P4_10",
      "id": "rP4_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 8")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Questions_P4#P4_11",
      "id": "rP4_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCUSSION")]), _vm._v(" Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTIONS")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em",
      "margin-top": "0em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780310354369_Acknowledgments_P4#P4_12",
      "id": "rP4_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#Author_13",
      "id": "rAuthor_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": ""
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780310354369_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/9780310354369_Chapter1_P4"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ebf9b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/nav.vue
// module id = 63
// module chunks = 0